import { SegmentedMessage } from "sms-segments-calculator";

export interface GsmSegment {
  text: string;
  isGsm: boolean;
}

const encodeAsTwilio = (text: string): SegmentedMessage => new SegmentedMessage(text, "auto", true);

export const findNonGsmCharacters = (text: string): Set<string> => {
  const nonGsm = new Set<string>();
  if (!text) return nonGsm;

  for (const { raw, isGSM7 } of encodeAsTwilio(text).encodedChars) {
    if (!isGSM7) nonGsm.add(raw);
  }

  return nonGsm;
};

/**
 * Group `text` into consecutive runs of GSM-7 and non-GSM-7 characters.
 *
 * Returns an empty array when every character is GSM-7 (including for empty
 * text), so callers can read "no segments" as "nothing to highlight".
 */
export const segmentByGsmStatus = (text: string): GsmSegment[] => {
  if (!text) return [];

  const segments: GsmSegment[] = [];
  let hasNonGsm = false;

  for (const { raw, isGSM7 } of encodeAsTwilio(text).encodedChars) {
    if (!isGSM7) hasNonGsm = true;

    const last = segments[segments.length - 1];
    if (last && last.isGsm === isGSM7) {
      last.text += raw;
    } else {
      segments.push({ text: raw, isGsm: isGSM7 });
    }
  }

  return hasNonGsm ? segments : [];
};

export const countTwilioCodeUnits = (text: string): number => {
  if (!text) return 0;
  return encodeAsTwilio(text).encodedChars.reduce((sum, ec) => sum + ec.codeUnits.length, 0);
};
